(function () {
    'use strict';

    angular
        .module('auditMandateModule')
        .controller('AuditMandatesListController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'historyCtxtService', 'auditMandateService', 'auditMandates'];

    function Controller($scope, $state, topBarService, historyCtxtService, auditMandateService, auditMandates) {

        topBarService.setTitleAndIcon('Audit Mandates', 'fa fa-road');

        $scope.auditMandates = auditMandates;

        // Go To Audit Mandate
        $scope.goToAuditMandate = function (item) {
            auditMandateService
                   .getAuditMandateByGovernanceProcessID(item.GovernanceProcessID)
                   .then(function (auditMandate) {
                       $state.go('auditMandateEdit', { AuditMandateID: auditMandate.AuditMandateID }, {});
                   });

        };
    }
})();